import { NavLink } from "react-router-dom"
import clsx from "clsx"

export interface SubNavItem {
  to: string
  label: string
  end?: boolean
}

export interface SubNavProps {
  items: SubNavItem[]
  className?: string
}

/**
 * Horizontal tab strip used for admin sub-nav. Glarchive uses it under the
 * Layout's top bar; other apps can drop in their own item list.
 */
export function SubNav({ items, className }: SubNavProps) {
  return (
    <nav className={clsx("flex flex-wrap gap-1 border-b border-th-glass/[0.08] pb-2 text-sm", className)}>
      {items.map((it) => (
        <NavLink
          key={it.to}
          to={it.to}
          end={it.end}
          className={({ isActive }) =>
            clsx(
              "rounded-lg px-3 py-1.5 text-th-fg/65 transition-colors hover:bg-th-glass/[0.06] hover:text-th-fg",
              isActive && "bg-th-glass/[0.1] text-th-fg"
            )
          }
        >
          {it.label}
        </NavLink>
      ))}
    </nav>
  )
}
